var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.959,
    height: 24.5,
    viewBox: "0 0 29.959 24.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General_Donation_History",
    "data-name": "General Donation History",
    transform: "translate(-102.75 -178.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10200",
    "data-name": "Path 10200",
    d: "M123.222,196.986a1.082,1.082,0,0,1-.383-.07l-3.6-1.209-6.885-2.349a10.086,10.086,0,0,1-3.932-2.29l-.023-.021-1.99-1.845-.024-.028a3.006,3.006,0,0,0-2.251-.911l-.049,0L103,188.188v-9.4h15.746a5.027,5.027,0,0,1,3.094,1.071l5.1,4.011a3.481,3.481,0,0,1,1.337,2.753v4.436l-.948-.316-.083-.027-.008,0-.041-.013-.009,0-.077-.023h0l-.094-.027-.106-.028-.008,0-.093-.022-.008,0-.1-.022-.008,0-.078-.015H126.6l-.081-.015-.01,0-.075-.013-.031-.005-.042-.006h-.006l-.1-.014h-.012l-.088-.01-.033,0-.062-.006-.059,0-.032,0-.062,0h-.041c-.05,0-.1-.005-.155-.006h-.225l-.082,0-.057,0-.059,0-.134.008h-.014l-.025,0-.018,0c-.1.009-.193.019-.283.032l-.064.009-.066.01-.014,0-.051.009-.026,0-.044.008-.009,0c-.075.014-.153.031-.24.052h-.006l-.041.01-.933.342v-3.63l-2.035-1.6a1.588,1.588,0,0,0-1.963,0l-.8.626a2.042,2.042,0,0,0-.712,2.161,2.309,2.309,0,0,0,1.347,1.521l2.971,1.225a3.868,3.868,0,0,1,2.1,5.053A1.086,1.086,0,0,1,123.222,196.986Zm-.327-1.222h0Zm-3.2-1.422,3.3,1.108a2.427,2.427,0,0,0-1.425-2.859l-2.971-1.225a3.751,3.751,0,0,1-2.187-2.468,3.48,3.48,0,0,1,1.213-3.681l.8-.626a3.025,3.025,0,0,1,3.741.005l2.108,1.66a1.243,1.243,0,0,1,.476.981v1.827q.1-.012.2-.021l.065-.006.022,0c.051,0,.108-.008.169-.01l.043,0h.018l.075,0,.1,0h.285c.062,0,.129,0,.2.008l.069,0,.039,0,.078.006.038,0,.022,0,.064.006h.015l.027,0c.042,0,.09.009.14.016l.132.018.063.01.026,0,.1.017.077.014v-2.507a2.05,2.05,0,0,0-.787-1.621l-5.1-4.01a3.579,3.579,0,0,0-2.2-.763H104.441v6.6a4.345,4.345,0,0,1,3,1.363l1.926,1.785a8.615,8.615,0,0,0,3.431,2.007l.015,0Zm4.515-3.715h0Zm1.9-.144h0Z",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10201",
    "data-name": "Path 10201",
    d: "M545.447,476.517a6.888,6.888,0,0,1-6.817-7.867l.124-.855,4.122,1.383a2.43,2.43,0,0,0-1.425-2.859l-1.7-.7.732-.762a6.869,6.869,0,0,1,3.246-1.9l.03-.007.037-.009.042-.01c.108-.026.208-.047.3-.066l.06-.011.022,0,.091-.015.1-.016.073-.011c.119-.017.237-.03.352-.04l.063-.006h.017l.178-.011h.012l.043,0h.01l.07,0,.109,0c.075,0,.151,0,.226,0h.051c.064,0,.133,0,.2.009l.046,0h.012l.05,0,.078.006.04,0,.106.01h.005l.151.017.129.017.078.012.013,0,.109.018.1.019h.006l.106.021.008,0,.133.03.137.033.119.031.022.006.114.032.078.023.051.015.025.008.065.021.045.015.011,0a6.889,6.889,0,0,1-2.215,13.411ZM540,469.733a5.446,5.446,0,1,0,7.2-5.262l-.052-.017-.037-.012-.043-.013-.023-.007-.063-.019-.013,0-.078-.022-.017,0-.092-.024-.01,0-.1-.023h-.006l-.1-.023-.085-.017h0l-.083-.015-.02,0-.056-.009-.029,0-.045-.007-.016,0-.1-.014-.1-.012-.017,0-.091-.008-.028,0-.042,0-.063,0h-.041c-.05,0-.1-.005-.154-.006h-.228l-.082,0h-.042l-.069,0-.135.008h-.016l-.023,0-.022,0c-.091.008-.185.018-.281.031l-.056.008-.073.012-.025,0-.043.007-.031.006-.035.007h-.008c-.075.014-.153.031-.24.052l-.1.025a5.406,5.406,0,0,0-1.728.793,3.876,3.876,0,0,1,1.755,4.89,1.086,1.086,0,0,1-1.39.6Zm2.768-.241h0S542.769,469.492,542.77,469.492Z",
    transform: "translate(-419.874 -273.727)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 1.441,
    height: 1.435,
    transform: "translate(124.852 198.393)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 1.441,
    height: 1.413,
    transform: "translate(124.852 191.978)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10202",
    "data-name": "Path 10202",
    d: "M664.2,570.673h-.9a1.9,1.9,0,0,1-1.915-1.873h1.441a.456.456,0,0,0,.475.433h.9a.555.555,0,0,0,.576-.53.506.506,0,0,0-.16-.366.6.6,0,0,0-.416-.164h-.9a2,2,0,0,1-2.016-1.971,1.935,1.935,0,0,1,.6-1.4,2.029,2.029,0,0,1,1.416-.568h.9a1.9,1.9,0,0,1,1.916,1.873h-1.441a.456.456,0,0,0-.475-.433h-.9a.6.6,0,0,0-.416.164.507.507,0,0,0-.16.366.555.555,0,0,0,.576.53h.9a2.027,2.027,0,0,1,1.416.568,1.935,1.935,0,0,1,.6,1.4A2,2,0,0,1,664.2,570.673Z",
    transform: "translate(-538.174 -371.559)",
    fill: "#444",
    stroke: "#444",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateIcon);
export default __webpack_public_path__ + "static/media/donateIcon.168231ef6d853e85e2a30f45e33fd22b.svg";
export { ForwardRef as ReactComponent };